<template>

    <!-- Start Tour Button -->
    <button @click="startTour" class="button button--large button--tour">
        <span class="visually-hidden">Start a Tour</span>
        <span class="icon icon--large icon--inline" aria-hidden="true">
            <svg class="icon__svg" height="43" viewBox="0 0 20 43" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10.8296 15.512c1.059-.444 2.318-.876 3.481-.683 2.45.408 2.196 3.56 1.85 5.357-.261 1.353-.717 2.658-1.131 3.97-.417 1.322-.794 2.656-1.129 4.002-.646 2.589-1.131 5.216-1.467 7.864.64-.181 1.27-.394 1.886-.646.24-.098.474-.207.708-.316.886-.613 1.761-1.244 2.628-1.882.273-.201.603.006.706.283.298.243.43.656.601 1.009.163.337-.032.747-.432.752-.072.001-.138.02-.206.034-.034.055-.078.106-.138.151-.032.023-.066.043-.098.067-.017.02-.026.044-.049.062-2.011 1.649-4.091 3.213-6.24 4.677-1.005.683-2.026 1.469-3.166 1.911-1.067.414-2.233.434-3.328.125-.149-.042-.235-.132-.289-.235-.293-.062-.59-.18-.881-.397-1.587-1.182-1.245-3.548-.941-5.24.215-1.193.677-2.327 1.076-3.474.122-.673.275-1.34.463-2 .221-1.613.586-3.197 1.097-4.745.025-.386.163-.734.411-1.028.118-.874.365-1.714.744-2.525-.007-.087-.01-.174-.03-.26-.02-.09-.052-.166-.083-.239-.098-.066-.178-.156-.192-.266-.002-.012 0-.023-.002-.035-.351-.364-.938-.369-1.516-.232l-3.657 2.498c-.291.199-.801-.06-.753-.432.058-.129.014-.209-.132-.24-.126-.055-.194-.156-.224-.271-.327-.087-.56-.568-.253-.846 2.18-1.979 4.702-3.501 7.246-4.962 1.124-.645 2.243-1.308 3.44-1.808zm-1.3295-14.1483c1.028-1.011 2.477-1.474 3.904-1.341 1.142.105 2.162.483 3.254.798.414.12.865.167 1.243.388.564.331.796.857 1.012 1.443.17.462.32.929.405 1.414.138.786.174 1.566-.032 2.346-.184.695-.546 1.27-.993 1.818-.62.757-1.465 1.372-2.359 1.765-2.081.914-4.846 1.084-6.74-.38-1.473-1.137-1.801-3-1.247-4.625-.116-.709.166-1.463.473-2.108.263-.556.642-1.087 1.08-1.518z" fill="#b70062" fill-rule="evenodd"/></svg>
        </span>
    </button>
</template>
<script>
  import { mapActions } from 'vuex'

  export default {
    methods: {
        ...mapActions({
            vuexSetTouring: 'setTouring',
        }),

        /*
         * Starts the tour
         *
         * @returns {void}
         */
        startTour() {

            // Set touring to true
            this.vuexSetTouring(true)
        },
    }
  }
</script>
